import React from "react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../../api/api";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/table";
import usePagination from "../../../utils/usePagination";
import BackButton from "../../../components/BackButton";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import Tooltip from "@mui/material/Tooltip";
 
const Transactions = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [invoiceData, setInvoiceData] = useState(null);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
 
  // Purchase Modal
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [purchaseEntries, setPurchaseEntries] = useState([]);
  const [loadingEntries, setLoadingEntries] = useState(false);
 
  const [showPerformaModal, setShowPerformaModal] = useState(false);
  const [performaInvoices, setPerformaInvoices] = useState([]);
  const [loadingPerforma, setLoadingPerforma] = useState(false);
 
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
 
 
 
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        setLoading(true);
 
        if (!token) {
          console.error("❌ No token found. Redirecting to login...");
          navigate("/login");
          return;
        }
 
        const res = await api.get("/billing/transactions");
 
        const data = res.data;
        console.log("data", data);
 
        const formattedData = data.transactions.map((item) => ({
          id: item.enq_id,
          job_number: item.job_number,
          customer_name: item.client_company,
          enq_id: item.enq_id,
          created_by: item.quotation_accepted_at
            ? new Date(item.quotation_accepted_at).toLocaleDateString("en-IN")
            : "",
        }));
 
        setClients(formattedData);
      } catch (error) {
        console.error("❌ Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };
 
    fetchTransactions();
  }, [token, navigate]);
 
  // =========================
  // Purchase Modal
  // =========================
 
  const openPurchaseModal = async (enquiry) => {
    setSelectedEnquiry(enquiry);
    setShowPurchaseModal(true);
    setPurchaseEntries([]);
    setLoadingEntries(true);
 
    try {
      const entryRes = await api.get(`/purchase/by-enquiry/${enquiry.enq_id}`);
 
      setPurchaseEntries(entryRes.data.entries || []);
    } catch (err) {
      setPurchaseEntries([]);
    } finally {
      setLoadingEntries(false);
    }
  };
 
  const openPerformaModal = async (enquiry) => {
    setSelectedEnquiry(enquiry);
    setShowPerformaModal(true);
    setPerformaInvoices([]);
    setLoadingPerforma(true);
 
    try {
      const invRes = await api.get(
        `/sale-invoices/by-enquiry/${enquiry.enq_id}`,
      );
      const entries = invRes.data?.entries || [];
      setPerformaInvoices(entries);
    } catch (err) {
      setPerformaInvoices([]);
    } finally {
      setLoadingPerforma(false);
    }
  };
 
  // Streams the already-generated PDF through the backend, the same way
  // ListofBLAdmin.js downloads a BL draft, instead of opening the Azure URL
  // directly. Keeps the download behind auth and gives the file a proper name.
  const handleDownloadInvoice = async (inv) => {
    if (!inv.pdf_url || !inv.sale_invoice_id) {
      alert(
        "PDF not available yet. Please generate the performa invoice first.",
      );
      return;
    }
 
    try {
      const response = await api.get(
        `/download-document/performa/${inv.sale_invoice_id}`,
        { responseType: "blob" },
      );
 
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Performa_Invoice_${inv.inv_number || inv.sale_invoice_id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download the invoice PDF. Please try again.");
    }
  };
 
  const filteredBySearch = clients.filter((client) =>
    client.customer_name?.toLowerCase().includes(search.toLowerCase()),
  );
 
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(filteredBySearch, 5);
 
  const columns = [
    {
      label: "Job Number",
      render: (c) => c.job_number,
    },
 
    {
      label: "Company Name",
      render: (c) => c.customer_name,
    },
 
    {
      label: "Date",
      render: (c) => c.created_by,
    },
 
    {
      label: "Purchase",
      render: (c) => (
        <div
          style={{
            cursor: "pointer",
            color: "#8393a2",
          }}
          title="View Purchase Entries"
          onClick={() => openPurchaseModal(c)}
        >
          <ShoppingCartOutlinedIcon />
        </div>
      ),
    },
 
    {
      label: "Income",
      render: (c) => (
        <div
          style={{ cursor: "pointer", color: "#8393a2" }}
          title="View Sale Invoices"
          onClick={() => openPerformaModal(c)}
        >
          <PaidOutlinedIcon />
        </div>
      ),
    },
  ];
 
  return (
    <>
      <BackButton />
 
      {/* Search */}
      <div className="mb-3 position-relative">
        <input
          type="search"
          className="form-control ps-5"
          placeholder="Search by Customer"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
 
        <SearchIcon
          style={{
            position: "absolute",
            left: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "#6b7280",
            width: "16px",
            height: "16px",
          }}
        />
      </div>
 
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No Transactions found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
 
      {/* =====================================================
          PURCHASE ENTRIES MODAL
      ====================================================== */}
 
      {showPurchaseModal && selectedEnquiry && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                maxHeight: "80vh",
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title">
                  Purchase Entries - {selectedEnquiry.job_number}
                </h5>
 
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPurchaseModal(false)}
                />
              </div>
 
              <div className="modal-body">
                {loadingEntries ? (
                  <div className="text-center py-4">
                    Loading purchase entries...
                  </div>
                ) : purchaseEntries.length === 0 ? (
                  <div className="text-center py-4 text-muted">
                    No purchase entries found for this enquiry.
                  </div>
                ) : (
                  <div
                    className="list-group purchase-entries-scroll"
                    style={{
                      maxHeight: "400px",
                      overflowY: "scroll",
                    }}
                  >
                    {purchaseEntries.map((entry) => (
                      <div
                        key={entry.purchase_invoice_id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <strong>
                            {entry.purchase_invoice_number ||
                              `#${entry.purchase_invoice_id}`}
                          </strong>
 
                          <br />
 
                          <small className="text-muted">
                            {entry.purchase_invoice_date
                              ? new Date(
                                  entry.purchase_invoice_date,
                                ).toLocaleDateString("en-IN")
                              : ""}
                          </small>
                        </div>
 
                        <Link
                          to={`/purchase-details/${entry.purchase_invoice_id}`}
                          className="btn btn-sm btn-primary"
                          onClick={() => setShowPurchaseModal(false)}
                        >
                          <EditOutlinedIcon
                            style={{
                              fontSize: 16,
                              marginRight: 4,
                            }}
                          />
                          Edit
                        </Link>
                      </div>
                    ))}
                  </div>
                )}
              </div>
 
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowPurchaseModal(false);
 
                    navigate(
                      `/purchase-details/new?enq_id=${selectedEnquiry.enq_id}`,
                    );
                  }}
                >
                  <AddCircleOutlinedIcon
                    style={{
                      fontSize: 18,
                      marginRight: 6,
                    }}
                  />
                  Add New Purchase Entry
                </button>
 
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowPurchaseModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
 
      {/* Performa Invoices Modal */}
      {showPerformaModal && selectedEnquiry && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          role="dialog"
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Sale Invoices - {selectedEnquiry.job_number}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPerformaModal(false)}
                />
              </div>
              <div className="modal-body">
                {loadingPerforma ? (
                  <div className="text-center py-4">
                    Loading sale invoices...
                  </div>
                ) : performaInvoices.length === 0 ? (
                  <div className="text-center py-4 text-muted">
                    No sale invoices created yet for this enquiry.
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Invoice Number</th>
                          <th>Invoice Type</th>
                          <th>Invoice Date</th>
                          <th>Created At</th>
                          <th style={{ width: "180px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {performaInvoices.map((inv) => (
                          <tr key={inv.sale_invoice_id}>
                            <td>{inv.inv_number || "—"}</td>
                            <td>
                              <span
                                className={`badge ${
                                  inv.invoice_type === "performa"
                                    ? "bg-secondary text-white"
                                    : "bg-warning"
                                }`}
                              >
                                {inv.invoice_type
                                  ? inv.invoice_type.charAt(0).toUpperCase() +
                                    inv.invoice_type.slice(1)
                                  : "—"}
                              </span>
                            </td>
                            <td>
                              {inv.invoice_date
                                ? new Date(inv.invoice_date).toLocaleDateString(
                                    "en-GB",
                                  )
                                : "—"}
                            </td>
                            <td>
                              {inv.created_at
                                ? new Date(inv.created_at).toLocaleString(
                                    "en-GB",
                                  )
                                : "—"}
                            </td>
                            <td>
                              <div className="d-flex justify-content-center gap-2">
                                <Tooltip title="View" arrow placement="top">
                                  <VisibilityOutlinedIcon
                                    style={{
                                      cursor: "pointer",
                                      fontSize: 20,
                                      color: "#8393a2",
                                    }}
                                    onClick={() => {
                                      setShowPerformaModal(false);
                                      // Read-only view of the saved invoice.
                                      // The id is the sale_invoice_id, so the
                                      // page loads real data from the database.
                                      navigate(
                                        `/view-performa-invoice/${inv.sale_invoice_id}`,
                                      );
                                    }}
                                  />
                                </Tooltip>
                                 {/* */}
<Tooltip title="Download" arrow placement="top">
                                   <DownloadIcon
                                     style={{
                                       cursor: "pointer",
                                       fontSize: 20,
                                       color: "#8393a2",
                                     }}
                                     onClick={() => handleDownloadInvoice(inv)}
                                   />
                                 </Tooltip>
                                 <Tooltip title="Edit" arrow placement="top">
                                   <EditOutlinedIcon
                                     style={{
                                       cursor: "pointer",
                                       fontSize: 20,
                                       color: "#8393a2",
                                     }}
onClick={() => {
                                        setShowPerformaModal(false);
                                        // Determine section index for Collect split reconstruction.
                                        // Backend returns invoices ORDER BY created_at DESC (newest first).
                                        // Original section index = creation order (oldest = 0).
                                        // So we reverse: sectionIndex = length - 1 - indexInDescArray
                                        const descIndex = performaInvoices.indexOf(inv);
                                        const sectionIndex = performaInvoices.length - 1 - descIndex;
                                        navigate(
                                          `/invoice-details/${selectedEnquiry.enq_id}?editSaleInvoiceId=${inv.sale_invoice_id}&editInvoiceSectionIdx=${sectionIndex}`,
                                        );
                                      }}
                                   />
                                 </Tooltip>
                               </div>
                             </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <Tooltip title="Create new invoice" arrow placement="top">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={() => {
                      setShowPerformaModal(false);
                      navigate(`/invoice-details/${selectedEnquiry.enq_id}`);
                    }}
                  >
                    <AddCircleOutlinedIcon style={{ fontSize: 18 }} />
                    Create Invoice
                  </button>
                </Tooltip>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowPerformaModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
 
      {(showPurchaseModal || showPerformaModal) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
};
 
export default Transactions;